import styled from "@emotion/styled";
import React from "react";
import useMedia from "react-use/lib/useMedia";
import { Link } from "../Link";
import { mobileUp, tabletUp } from "../theme/ecologi-breakpoints";
export interface TopNavigationProps {
  leftSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
  loggedOutNav?: boolean;
}

const CenteredLink = styled(Link)`
  display: inline-flex;
`;

const Logo = styled.img`
  margin-left: 24px;
  height: 52px;
  width: 100px;

  &:hover {
    opacity: 0.8;
  }

  @media ${(props) => props.theme.bp.desktopUp} {
    margin-left: 36px;
  }
`;

const CentralContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.forest};
  align-items: center;
  height: 104px;
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
`;

const RightSlot = styled.div<{ loggedOutNav?: boolean }>`
  margin-right: 112px;
  @media ${(props) => props.theme.bp.tabletUp} {
    margin-right: ${(props) => (props.loggedOutNav ? "112px" : "42px")};
  }
`;

const LeftSlot = styled.div`
  display: flex;
  align-items: centre;
  padding-left: 24px;
  min-height: 48px;
  background-color: ${(props) => props.theme.colors.forestDark};
  @media ${(props) => props.theme.bp.mobileUp} {
    background-color: ${(props) => props.theme.colors.forest};
    padding-left: 42px;
  }
`;

const Header = styled.header`
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  z-index: 500;
`;

export function TopNavigation({
  leftSlot,
  rightSlot,
  loggedOutNav,
}: TopNavigationProps) {
  const isDesktop = useMedia(tabletUp);
  const isMobile = useMedia(mobileUp);
  return (
    <Header>
      <CentralContainer>
        <LeftContainer>
          {(loggedOutNav || !isDesktop) && (
            <CenteredLink href="/">
              <Logo src={"/images/app/intrepid/ecologi-logo.svg"} />
            </CenteredLink>
          )}
          {isMobile && leftSlot && <LeftSlot>{leftSlot}</LeftSlot>}
        </LeftContainer>
        <RightSlot loggedOutNav={loggedOutNav}>{rightSlot}</RightSlot>
      </CentralContainer>
      {!isMobile && leftSlot && <LeftSlot>{leftSlot}</LeftSlot>}
    </Header>
  );
}
